module.exports = __webpack_public_path__ + "static/img/close_status.f4c4d18b.png";